module.exports = __webpack_public_path__ + "img/teacat_img_scan_error.c9a8c851.png";